import { useCallback, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { reload } from '../../../../../../helpers';
import Auth from '../../../../../../services/AuthService';
import ThemeProvider from '../../../../../paymentJourneyRedesign/muiTheme/ThemeProvider';
import FormContainer from '../../../../../paymentJourneyRedesign/shared/formElements/FormContainer';
import TextField from '../../../../../paymentJourneyRedesign/shared/formElements/TextField';
import CallToAction from '../../../../../shared/CallToAction/CallToAction';
import FormError from '../FormError';
import gtmService from '../../../../../../utils/gtm';
import s from './LoginForm.module.scss';

const FORM_TITLE = 'Already have an account?';

export default function LoginForm() {
  const { t } = useTranslation();
  const [submitError, setSubmitError] = useState('');

  const form = useForm({
    defaultValues: { email: '', password: '' },
  });
  const {
    formState: { isSubmitting },
  } = form;

  const handleSubmit = useCallback(
    async (values) => {
      setSubmitError('');

      const response = await Auth.login({
        username: values.email,
        password: values.password,
      });
      const data = await response.json();

      if (response.ok) {
        Auth.setToken(data);
        gtmService.ga4UserLogin(
          'User login from downloadable agenda',
          'downloadable_agenda_form_id',
          FORM_TITLE,
        );
        reload();
        return;
      }

      switch (data.errorCode) {
        case 'PASSWORD_RESET_REQUIRED':
          setSubmitError(t('component.login.errors.password-expired'));
          break;

        case 'USER_NOT_FOUND':
          setSubmitError(t('component.login.errors.account-not-found'));
          break;

        default:
          setSubmitError(data.error);
          break;
      }
    },
    [t],
  );

  return (
    <div className={s.wrapper}>
      <div className={s.alreadyRegisteredText}>{FORM_TITLE}</div>
      <div className={s.loginRequestText}>
        If you have an account, please login and download.
      </div>
      <ThemeProvider>
        <FormContainer form={form} onSubmit={handleSubmit}>
          <div className="row">
            <div className="col-xs-12 col-sm-6">
              <TextField
                type="email"
                name="email"
                label="Username"
                rules={{ required: true }}
              />
            </div>
            <div className="col-xs-12 col-sm-6">
              <TextField
                type="password"
                name="password"
                label="Password"
                rules={{ required: true }}
              />
              <a
                href="/account/forgotten-password/"
                className={s.forgotPasswordAnchor}
              >
                Forgot you password?
              </a>
            </div>
          </div>
          {submitError && (
            <div className={s.submitError}>
              <FormError>{submitError}</FormError>
            </div>
          )}
          <CallToAction
            type="submit"
            className={s.loginButton}
            disabled={isSubmitting}
          >
            Login to access
          </CallToAction>
        </FormContainer>
      </ThemeProvider>
    </div>
  );
}
